import { useMemo, useState } from "react";
import {
  ConversationItem,
  ConversationTypeEnum,
  ReplyOption
} from "@coxauto-ui/cxm/communications/interfaces";
import { SignatureApiErrorType } from "@coxauto-ui/cxm/communications/api";
import { IConversationDetailsContext } from "../context";

export function useConversationDetailsState(): IConversationDetailsContext {
  const [conversationItems, setConversationItems] = useState<
    ConversationItem[]
  >([]);
  const [displayConversationItems, setDisplayConversationItems] = useState<
    ConversationItem[]
  >([]);
  const [selectedConversationItem, setSelectedConversationItem] =
    useState<ConversationItem | null>(null);
  const [recentContactEmail, setRecentContactEmail] = useState("");
  const [recentContactText, setRecentContactText] = useState("");
  const [xSignature, setXSignature] = useState("");
  const [latestConversationItemType, setLatestConversationItemType] =
    useState<ConversationTypeEnum | null>(null);
  const [currentConversationType, setCurrentConversationType] =
    useState<ConversationTypeEnum | null>(null);
  const [showGenerativeAI, setShowGenerativeAI] = useState(false);
  const [isSuggestEdit, setIsSuggestEdit] = useState(false);
  const [emojiPickerError, setEmojiPickerError] = useState(false);
  const [signatureInsertError, setSignatureInsertError] =
    useState<SignatureApiErrorType | null>(null);
  const [selectedReplyOption, setSelectedReplyOption] =
    useState<ReplyOption | null>(null);

  // toggleSetShowReply is intentionally left as a no-op placeholder
  // It will be overridden in conversation-pane.tsx where it has access to showReply state
  const toggleSetShowReply = () => {
    // Placeholder - will be overridden
  };

  return useMemo(
    () => ({
      conversationItems,
      displayConversationItems,
      selectedConversationItem,
      recentContactEmail,
      recentContactText,
      xSignature,
      latestConversationItemType,
      currentConversationType,
      showGenerativeAI,
      isSuggestEdit,
      emojiPickerError,
      signatureInsertError,
      selectedReplyOption,
      setConversationItems,
      setDisplayConversationItems,
      setSelectedConversationItem,
      setRecentContactEmail,
      setRecentContactText,
      setXSignature,
      setLatestConversationItemType,
      setCurrentConversationType,
      setShowGenerativeAI,
      setIsSuggestEdit,
      setEmojiPickerError,
      setSignatureInsertError,
      setSelectedReplyOption,
      toggleSetShowReply
    }),
    [
      conversationItems,
      displayConversationItems,
      selectedConversationItem,
      recentContactEmail,
      recentContactText,
      xSignature,
      latestConversationItemType,
      currentConversationType,
      showGenerativeAI,
      isSuggestEdit,
      emojiPickerError,
      signatureInsertError,
      selectedReplyOption
    ]
  );
}
